import { cn } from "@/utils/cn";
import React from "react";

export const StatusScreen = React.memo(function StatusScreen(props: {
  emoji?: string;
  title: string;
  subtitle: React.ReactNode;
  fullScreen?: boolean; // covers the full viewport instead of just filling its container
  height?: "viewport" | "content";
  children?: React.ReactNode; // action buttons
}) {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-center gap-5 bg-surface px-6 py-8 text-center",
        props.fullScreen
          ? "fixed inset-0 z-9999 h-auto"
          : props.height === "content"
            ? "h-auto"
            : "h-screen"
      )}
    >
      {props.emoji ? (
        <div className="text-[90px] leading-none" aria-hidden="true">
          {props.emoji}
        </div>
      ) : null}
      <h1 className="m-0 text-heading font-bold text-body-text">
        {props.title}
      </h1>
      <p className="m-0 max-w-80 text-body-lg font-normal text-body-text">
        {props.subtitle}
      </p>
      <div className="flex w-full max-w-70 flex-col gap-1.25">
        {props.children}
      </div>
    </div>
  );
});
